import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import MText from '../../../../../components/Common/MText';
import withLoyaltyConnect from '../WithLoyaltyConnect';
import LoyaltyMenuDescriptionBox from '../../../../../components/LoyaltyMenuDescriptionBox';
import PreviewLoyaltyCard from '../Preview/PreviewLoyaltyCard';
import { PreviewNote } from '../Preview/Preview';

const Status = (props) => {
  useEffect(() => {
    props.showAdvancedStatusBtn();

    return () => {
      props.hideAdvancedStatusBtn();
    };
  }, []);

  return (
    <div className="px-0 row pt-3">
      <div className="col-12 col-md-6 col-lg-8">
        <LoyaltyMenuDescriptionBox
          text="After all the fields in the prior tabs have been completed, you can set the Loyalty Card to ‘live’ and allow users to start collecting stamps.  If you wish to stop the Loyalty Card, you can also choose to ‘Deactivate’ the Loyalty Card."
        />
        <MText text="Loyalty Programme Status" size={13} className="my-3" />
        <div className="d-flex justify-content-center">
          <div style={{ maxWidth: 250 }}>
            <PreviewLoyaltyCard />
            <PreviewNote />
          </div>
        </div>
      </div>
    </div>
  );
};

Status.propTypes = {
  showAdvancedStatusBtn: PropTypes.func.isRequired,
  hideAdvancedStatusBtn: PropTypes.func.isRequired,
};

export default withLoyaltyConnect(Status);
